import React, { useContext, useEffect, useState } from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';
import { IntlProvider } from 'react-intl';

import { useSettings } from '../mall_settings/SettingsProvider';

import { getCurrencyFormats } from './intlFormats';

export const MallIntlContext = React.createContext();

export const IntlMessageProvider = ({ locale, initialMessages, children }) => {
    const { messagesUrl, mallCode } = useSettings();
    const [messages, setMessages] = useState(initialMessages);
    const [currentLocale, setCurrentLocale] = useState(locale);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(false);

    useEffect(() => {
        const source = axios.CancelToken.source();
        const fetchData = async () => {
            setError(false);
            setIsLoading(true);

            try {
                const response = await axios.get(`${messagesUrl}/${mallCode}/${currentLocale.replace('-', '/')}.json`);
                setMessages(response.data);
            } catch (axiosError) {
                if (error.response) {
                    setError(axiosError.response.data);
                } else if (error.request) {
                    setError(axiosError.request);
                } else {
                    setError(axiosError.toString());
                }
            }
            setIsLoading(false);
        };

        fetchData();

        return () => {
            source.cancel();
        };

    }, [currentLocale]);

    return (
        <MallIntlContext.Provider
            value={{ messages, setMessages, currentLocale, setCurrentLocale, isLoading, setIsLoading, error, setError }}
        >
            <IntlProvider
                key={currentLocale}
                locale={currentLocale}
                messages={messages}
                formats={getCurrencyFormats('USD')}
            >
                {children}
            </IntlProvider>
        </MallIntlContext.Provider>
    );
};

IntlMessageProvider.propTypes = {
    locale: PropTypes.string.isRequired,
    children: PropTypes.object.isRequired,
    initialMessages: PropTypes.object.isRequired
};

export const useMallIntl = () => useContext(MallIntlContext);
